import { motion } from "framer-motion";
import { TRUST_STATS } from "./data";

export const TrustSignals = () => (
  <section className="border-b border-[#D4AF37]/10 bg-[#F3EEE2]" data-testid="trust-signals-section">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-px overflow-hidden bg-[#D4AF37]/10 sm:grid-cols-3 lg:grid-cols-6">
      {TRUST_STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, delay: i * 0.07 }}
          className="flex flex-col items-center bg-[#F3EEE2] px-4 py-10 text-center"
          data-testid={`trust-stat-${i}`}
        >
          <p className="font-serif-display text-3xl font-semibold text-[#A07E1F] sm:text-4xl">{s.value}</p>
          <p className="mt-2 font-mono-accent text-[9px] uppercase tracking-[0.22em] text-[#5E6E85] sm:text-[10px]">{s.label}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
